import { useState, useEffect, useRef } from 'react';
import { Assets } from "../../src/list/Assets";

const MobileExitButton = ({ onClick }) => {
  const [isDragging, setIsDragging] = useState(false);
  const [offsetY, setOffsetY] = useState(0);
  const buttonRef = useRef(null);
  const startPos = useRef({ y: 0, top: 0 });

  useEffect(() => {
    const handleMouseMove = (event) => {
      if (isDragging) {
        const newTop = startPos.current.top + event.clientY - startPos.current.y;
        setOffsetY(newTop);
      }
    };

    const handleMouseUp = () => {
      setIsDragging(false);
    };

    const handleTouchMove = (event) => {
      if (isDragging) {
        const touch = event.touches[0];
        const newTop = startPos.current.top + touch.clientY - startPos.current.y;
        setOffsetY(newTop);
      }
    };

    const handleTouchEnd = () => {
      setIsDragging(false);
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);
    window.addEventListener('touchmove', handleTouchMove, { passive: false });
    window.addEventListener('touchend', handleTouchEnd);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
      window.removeEventListener('touchmove', handleTouchMove);
      window.removeEventListener('touchend', handleTouchEnd);
    };
  }, [isDragging]);

  const handleMouseDown = (event) => {
    setIsDragging(true);
    startPos.current = {
      y: event.clientY,
      top: offsetY,
    };
  };

  const handleTouchStart = (event) => {
    setIsDragging(true);
    const touch = event.touches[0];
    startPos.current = {
      y: touch.clientY,
      top: offsetY,
    };
  };

  return (
    <button
      ref={buttonRef}
      style={{
        position: 'fixed',
        top: `${offsetY}px`,
        zIndex: 1000,
        cursor: 'pointer',
        padding:  '0px',
        background: "none",
        border: 'none',
        
      }}
      onMouseDown={handleMouseDown}
      onTouchStart={handleTouchStart}
      onClick={onClick}
    >
      <div className="mobile-exit">
        <img
          alt="Back"
          title="Back button"
          src={Assets[0].mback_icon}
        />
      </div>
    </button>
  );
};

export default MobileExitButton;
